<div class="flagged-icon">
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3146_4746)">
      <path
        d="M3.33252 3.33341C3.95562 2.72265 4.79334 2.38055 5.66585 2.38055C6.53836 2.38055 7.37609 2.72265 7.99919 3.33341C8.62228 3.94417 9.46001 4.28627 10.3325 4.28627C11.205 4.28627 12.0428 3.94417 12.6659 3.33341V9.33341C12.0428 9.94417 11.205 10.2863 10.3325 10.2863C9.46001 10.2863 8.62228 9.94417 7.99919 9.33341C7.37609 8.72265 6.53836 8.38055 5.66585 8.38055C4.79334 8.38055 3.95562 8.72265 3.33252 9.33341V3.33341Z"
        stroke="#FA0000"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33252 13.9992V9.33258"
        stroke="#FA0000"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3146_4746">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</div>
